module.exports = __webpack_public_path__ + "static/media/idun12.ff316481.JPG";